module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "item-wrapper"
  }, [_c('div', {
    staticClass: "item-wrapper-top"
  }, [_c('div', {
    staticClass: "item-wrapper-top-title"
  }, [_vm._v("\n        是否自动派M4\n      ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "开启",
      "inactive-text": "关闭"
    },
    on: {
      "change": _vm.handleAutomaticDispatchM4Change
    },
    model: {
      value: (_vm.automaticDispatchM4),
      callback: function($$v) {
        _vm.automaticDispatchM4 = $$v
      },
      expression: "automaticDispatchM4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-wrapper-bottom"
  }, [_c('el-alert', {
    attrs: {
      "type": "warning",
      "show-icon": true,
      "closable": false
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [_vm._v("\n            【关闭】表示极吼吼小程序的订单产生后（此时工单状态为“待确认”），依旧进入现有的“待处理”页（由人工点击底部“转单M4”按钮，传入M4）\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n            【开启】表示极吼吼小程序的订单产生后（此时工单状态为“待确认”），由系统代替人工立即（全部默认点击了“转单M4”按钮的效果）传入M4。\n          ")])]
      },
      proxy: true
    }])
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-87503324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/dispatchConfiguration/index.vue
// module id = 1717
// module chunks = 0